<z-modal open="true" [color]="'bg-exp'">
    <ng-container header>
        <div class="flex flex-row gap-2 items-center">
            <i
                class="fal fa-user text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
            <h4 class="text-2xl font-bold text-zen">
                {{ 'txtChangePasswordTitle' | translate:language:ModuleNames.Common }}
            </h4>
        </div>
    </ng-container>

    <ng-container body>
        <div class="flex flex-row items-start gap-5">
            <form autocomplete="off" [formGroup]="form" class="flex flex-col w-full">
                <div class="flex flex-row gap-1 items-center w-full ">

                    <z-input class="w-full" [password]="true" [required]="true" [language]="language"
                        [label]="'txtPassword' | translate: language:ModuleNames.Common"
                        formControlName="newPassword"></z-input>


                    <a class="mt-6" (click)="generatePassword()" zenButton styles="secondary icon-9"
                        [matTooltip]="'GeneratePassword'|translate:language:ModuleNames.Shared"><i
                            class="fa-regular fa-key-skeleton-left-right"></i></a>

                    <a class="mt-6" *ngIf="generatedPassword" (click)="copyPassword()" zenButton
                        styles="secondary icon-9" [matTooltip]="'CopyPassword'|translate:language:ModuleNames.Shared"><i
                            class="fa-regular fa-copy"></i></a>

                </div>
                <h5 *ngIf="form.get('newPassword')?.errors as errors">
                    <validation-required *ngIf="errors.required && form.get('newPassword').dirty"
                        [language]="language"></validation-required>
                    <div *ngIf="errors.minlength"
                        class="text-red-600 text-xxs flex flex-row items-center gap-1 leading-5">
                        <i class="fa-solid fa-exclamation-circle"></i>
                        <span>
                            {{ 'txtMinLength' | translate:language:ModuleNames.Common }} :
                            {{errors.minlength.requiredLength}}
                        </span>

                    </div>
                </h5>

            </form>
            <div class="flex flex-row items-center justify-end gap-2 -mt-2">

            </div>
        </div>




    </ng-container>

    <ng-container footer>
        <a (click)="closeModal()"
            class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{
            "btn_cancel" |
            translate: language:ModuleNames.Common }}</a>
        <a (click)="changePassword()"
            class="btn exp text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">
            {{ "txtBtnChangePassword" | translate: language:ModuleNames.Common }}
        </a>
    </ng-container>
</z-modal>